import { defineSlotRecipe } from '@chakra-ui/react';
import { TextStyles, Radii, Colors, Shadows, Sizes, Space } from '../../types';

export const tooltipSlotRecipe = defineSlotRecipe({
  slots: ['trigger', 'positioner', 'content', 'arrow', 'arrowTip'],
  base: {
    content: {
      '--tooltip-bg': `colors.${Colors.SURFACE_ELEVATED_INVERT}`,
      bg: Colors.SURFACE_ELEVATED_INVERT,
      borderRadius: Radii.BASE,
      boxShadow: Shadows.XS,
      maxW: Sizes['3XS'],
      minW: Space.SPACE_4,
      minH: Space.SPACE_4,
      color: Colors.TEXT_EMPHASIS_INVERT,
      textStyle: TextStyles.P3,
      py: Space['2XS'],
      px: Space.XS,
    },
    arrow: {
      '--arrow-background': `colors.${Colors.SURFACE_ELEVATED_INVERT}`,
    },
    arrowTip: {
      borderTopWidth: '1px',
      borderLeftWidth: '1px',
      borderColor: 'var(--arrow-background)',
      borderRadius: '1.5px',
    },
  },
});
